module.exports = __webpack_public_path__ + "static/media/darkOak.61538f29.jpg";